import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { MultiValuesChip } from "../common/multi-values-chip";
import { sort } from "@utils/sort";
export const sortPredicate = sort();
export function UsersTableConfig({ debouncedSearchKey, handleUserUpdate }) {
    const intl = useIntl();
    const usersParams = useMemo(() => {
        return {
            include: ["policies"],
        };
    }, [handleUserUpdate]);
    const userRowTransform = useCallback((row) => {
        var _a, _b, _c;
        const decoratedRow = row;
        if (debouncedSearchKey) {
            const searchKey = debouncedSearchKey.toLowerCase();
            if ((_a = row._id) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_b = row.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_c = row.email) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchKey))
                return decoratedRow;
            if (row.organizations) {
                for (const organization of row.organizations) {
                    if (organization.name && organization.name.toLowerCase().includes(searchKey)) {
                        return decoratedRow;
                    }
                }
            }
            if (row.communities) {
                for (const community of row.communities) {
                    if (community.name && community.name.toLowerCase().includes(searchKey)) {
                        return decoratedRow;
                    }
                }
            }
            return null;
        }
        return decoratedRow;
    }, [debouncedSearchKey]);
    const usersColumns = useMemo(() => {
        return [
            {
                id: "id",
                label: intl.formatMessage(messages.id),
                sortable: false,
                accessor: "_id",
            },
            {
                id: "name",
                label: intl.formatMessage(messages.name),
                sortable: false,
                accessor: "name",
            },
            {
                id: "email",
                label: intl.formatMessage(messages.email),
                sortable: false,
                accessor: "email",
            },
            {
                id: "role.name",
                label: intl.formatMessage(messages.type),
                sortable: false,
                render: (row) => {
                    var _a, _b;
                    const parts = [];
                    if ((_a = row.role) === null || _a === void 0 ? void 0 : _a.name)
                        parts.push(row.role.name);
                    if ((_b = row.discoverRole) === null || _b === void 0 ? void 0 : _b.name)
                        parts.push(row.discoverRole.name);
                    if (row.insightsRoleId)
                        parts.push("Insights");
                    return parts.join(", ") || "-";
                },
            },
            {
                id: "organization.name",
                label: intl.formatMessage(messages.organizations),
                sortable: false,
                render: (row) => React.createElement(MultiValuesChip, { values: row.organizations }),
            },
            {
                id: "communities.name",
                label: intl.formatMessage(messages.communities),
                sortable: false,
                render: (row) => React.createElement(MultiValuesChip, { values: row.communities }),
            },
        ];
    }, []);
    return {
        usersParams,
        usersColumns,
        userRowTransform,
    };
}
